<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },

        type: {
            type: String,
            required: true
        }
    },

    computed: {
        name() {
            return this.type === 'clinicalResearch'
                ? this.item.title
                : this.item.name;
        },

        isExternalLink() {
            return (
                (this.type === 'article' && this.item.url) ||
                (this.type === 'event' && this.item.externalLink)
            );
        },

        internalLink() {
            if (this.type === 'article') {
                return this.$getArticleLink(this.item);
            }

            if (this.type === 'category') {
                return this.localePath(
                    `/${
                        this.item.parentCategoryId
                            ? 'subcategories'
                            : 'categories'
                    }/${this.item.slug}`
                );
            }

            if (this.type === 'forum') {
                return this.localePath(`/forum/${this.item.slug}`);
            }

            if (this.type === 'event') {
                return this.item.article
                    ? this.$getArticleLink(this.item.article)
                    : this.localePath('/events');
            }

            if (this.type === 'drug') {
                return this.localePath(`/drugs/${this.item.slug}`);
            }

            if (this.type === 'clinicalResearch') {
                return this.localePath(
                    `/clinical-researches/categories/${this.item.id}`
                );
            }

            if (this.type === 'page') {
                return this.localePath(`/${this.item.url}`);
            }

            return '/';
        },

        externalLink() {
            if (this.type === 'article') {
                return this.item.url;
            }

            if (this.type === 'event') {
                return this.item.externalLink;
            }

            return '/';
        },

        additionalAttributes() {
            return this.item.blank ? { target: '_blank' } : {};
        }
    }
};
</script>
